import React, { useEffect, useState } from "react";
import MainDetails from "./main-details";
import Input from "../../components/preview-input/input";
import Drawing from "./drawing";
import MeasurementsLeft from "./measurements-left";
import MeasurementsRight from "./measurements-right";
import Fascia from "./fascia";
import Soffit from "./soffit";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import Success from "../../components/success/success";
import usePreviewStore from "../../store/preview-store";
import axiosInstance, { endpoints } from "../../utils/axios";
import axios from "axios";
import { HOST_API, SALES_FORCE_LOGIN_URL } from "../../config-global";
import { toast } from "react-toastify";
import { convertErrorsToArray } from "../../utils/formats";
import useResultStore from "../../store/result-store";
import { Loader } from "@progress/kendo-react-indicators";
import qs from "querystring";
import { getDataForSalesFor } from "./utilts";
import TableComponent from "./table-component";
import { onSubmitDate } from "./finnal-submit";
const Preview = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);
  const { previewData, setFormData, reset } = usePreviewStore();
  const [showButton, setShowButton] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const leadId = queryParams.get("leadId");
  const [pricesValues, setPricesValue] = useState();
  const { resultData } = useResultStore();
  const [getLeadLoading, setGetLeadLoading] = useState(false);
  const [isDraft, setDraft] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [leadResultsDetail, setLeadResultDetails] = useState(null);
  const [leadDetails, setLeadDetails] = useState(null);
  useEffect(() => {
    getSheet();
    getleadDetails();
  }, []);

  const getleadDetails = async () => {
    try {
      const response = await axiosInstance.get(
        endpoints.leads.get_lead_detail(id)
      );
      if (response.data) {
        if (response.data.data?.results) {
          setLeadDetails(response.data.data);
          setLeadResultDetails({
            resultType: response.data.data?.results?.resultType,
            resultReason: response.data.data?.results?.resultReason,
            oneLeg: response.data.data?.results?.oneLeg,
            lastPrice: response.data.data?.results?.lastPrice,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching :", error);
    }
  };
  const salesForceLogin = async (payload) => {
    try {
      const response = await axiosInstance.get(endpoints.salesForce.login);
      await salesForceGutterSheet(response.data.access_token, payload);
    } catch (error) {
      console.error(
        "Error Logging into Salesforce:",
        error.response?.data || error.message
      );
    }
  };
  function startsWithError(message) {
    return message.startsWith("Error");
  }
  const salesForceGutterSheet = async (token, data) => {
    try {
      const response = await axios.post(
        `https://abc742-dev-ed.develop.my.salesforce.com/services/apexrest/api/GuttersAPI`,
        JSON.stringify(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (startsWithError(response.data)) {
        // toast.error(`Error in SF Api : ${response.data}`);
      }
    } catch (error) {
      console.error(
        "Error Logging into Salesforce:",
        error.response?.data || error.message
      );
    }
  };
  function convertToRoofTypeArray(roofTypeStr) {
    return roofTypeStr.split(",").map((type) => type.trim());
  }

  const getSheet = async () => {
    setGetLeadLoading(true);
    try {
      const response = await axiosInstance.get(
        endpoints.leads.get_sheet_detail(leadId)
      );
      if (response.data) {
        setGetLeadLoading(false);
        let data = response.data.data;
        if (data.customer) {
          setDraft(data.isDraft || false);
          const values = {
            customer: data.customer || "",
            city: data.city || "",
            st: data.street || "",
            gutter_height: data.gutterHeight || [],
            newMeterInside: data.newMeterInside || 0,
            newMeterOutSide: data.newMeterOutside || 0,
            measurements: data.measurements,
            roof_type: convertToRoofTypeArray(data.roof.roofType) || "",
            ribbedRoofQuantity: data.ribbedRoofQuantity || 0,
            gutter_type: data.roof.gutterType || "",
            color: data.roof.gutterColor || "",
            gutter_size: data.roof.gutterSize || "",
            total_gutter_footage: data.roof.totalGutterFootage || "",
            downspout: data.roof.downSpout || "",
            downspout_color: data.roof.downSpoutColor || "",
            aelbows: data.roof.downSpoutFootage.ofAElbows || "",
            belbows: data.roof.downSpoutFootage.ofBElbows || "",
            roundElbows: data.roof.downSpoutFootage.ofRoundElbows || "",
            offsetElbows: data.roof.downSpoutFootage.ofOffsetElbows || "",
            downspout_footage: data.roof.downSpoutFootage.totalFootage || "",
            outside: data?.misc?.ofMitersOutside || "",
            inside: data?.misc?.ofMitersInside || "",
            rights: data?.misc?.ofEndcapsRights || "",
            lefts: data?.misc?.ofEndcapsLefts || "",
            savers: data?.misc?.ofSproutSavers || "",
            straps: data?.misc?.ofRoofStraps || "",
            wedges: data?.misc?.ofwedges || "",
            partial_install: data?.misc?.partialInstall ? "Yes" : "No",
            fascia_replacement: data?.fasciaReplacement?.type || "",
            fascia_total_footage: data?.fasciaReplacement?.totalFootage || "",
            fascia_size:
              data?.fasciaReplacement?.size != "1x4" &&
              data?.fasciaReplacement?.size != "1x6" &&
              data?.fasciaReplacement?.size != "1x8" &&
              data?.fasciaReplacement?.size != "1x10"
                ? "Other"
                : data?.fasciaReplacement?.size,
            fascia_other_size: data?.fasciaReplacement?.size,
            fascia_type: data?.fasciaReplacement?.productType || "",
            fascia_color: data?.fasciaReplacement?.fascia_color || "",
            soffit_other_value:
              data?.fasciaReplacement?.productType != "Painted" &&
              data?.fasciaReplacement?.productType != "Metal Wrapped "
                ? data?.fasciaReplacement?.productType
                : "",
            fascia_other:
              data?.fasciaReplacement?.productDetail != "Painted" &&
              data?.fasciaReplacement?.productDetail != "Metal Wrapped"
                ? "Other"
                : data?.fasciaReplacement?.productDetail,
            fascia_other_value:
              data?.fasciaReplacement?.productDetail != "Painted" &&
              data?.fasciaReplacement?.productDetail != "Metal Wrapped"
                ? data?.fasciaReplacement?.productDetail
                : "",
            metal_wrapped_color: data?.metalWrappedColor || "WHITE",
            fascia_wrap: data?.fasciaReplacement?.totalFtOfNewWrap || "",
            soffit_replacement: data?.soffitReplacement?.replacementType || "",
            soffit_other:
              data?.soffitReplacement?.soffitType != "Wood" &&
              data?.soffitReplacement?.soffitType != "Vinyl"
                ? "Other"
                : data?.soffitReplacement?.soffitType,
            soffit_other_value:
              data?.soffitReplacement?.soffitType != "Wood" &&
              data?.soffitReplacement?.soffitType != "Vinyl"
                ? data?.soffitReplacement?.soffitType
                : "",
            soffit_color: data?.soffitReplacement?.soffitColor || "None",
            soffit_total_footage: data?.soffitReplacement?.totalFootage || "",
            porch_ceiling: data?.porchCeiling,
            images: data.images,
          };
          setFormData(values);
          setShowButton(false);
          setLoading(false);
        } else {
          setShowButton(true);
          setLoading(false);
        }
      }
    } catch (error) {
      setGetLeadLoading(false);
      console.error("Error fetching :", error);
    } finally {
      setGetLeadLoading(false);
    }
  };
  const onSubmit = async (url, draft) => {
    const formData =await onSubmitDate(
      url,
      draft,
      previewData,
      leadId,
      resultData,
      leadResultsDetail
    );
    try {
      const response = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);
      setDraftLoading(false);
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        navigate(`/leads/${id}`);
      }, 2000);
    } catch (error) {
      setLoading(false);
      console.error("Error submitting data:", error?.response?.data?.data);
      const errorsArray = convertErrorsToArray(error?.response?.data?.data);

      if (errorsArray.length > 0) {
        errorsArray.forEach((err) => toast.error(err));
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("Internal Server Error");
      }
    } finally {
      setDraftLoading(false);
      setLoading(false);
    }
  };
  return getLeadLoading ? (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader themeColor="success" />
    </div>
  ) : (
    <div className="">
      <h2 className="k-py-4 k-font-bold">Preview</h2>
      <div className="k-rounded-lg k-p-4" style={{ background: "#FFFFFF" }}>
        <div
          className=" k-px-8 k-sm-px-2 k-w-sm--100 k-border-solid k-border k-border-black"
          style={{ width: "60%" }}
        >
          <h2 className="k-text-right k-m-0 k-py-3 k-responsive-text">
            Gutter / Fascia / Soffit Prep Form
          </h2>
        </div>
        <div className="k-border-solid k-border k-border-black k-mt-1">
          <MainDetails id={id} />
        </div>
        <div className=" k-px-2 k-border-solid k-border k-border-black k-mt-1">
          <h2 className="k-m-0 k-py-3">
            Measurements (list each run separate and round up to the nearest
            foot)
          </h2>
        </div>

        <div className="k-px-2 k-border-solid k-border k-border-black k-mt-1 k-d-grid k-grid-cols-2 k-grid-sm-cols-1">
          <MeasurementsLeft />

          <MeasurementsRight />
        </div>

        <Fascia />

        <Soffit />
      </div>
      {!leadDetails?.mhalt ? (
        <div className="k-w-full k-d-flex k-justify-content-end k-my-8">
          <Button
            onClick={() => navigate(`/leads/${id}`)}
            primary={true}
            className="k-button-red2 k-mr-2"
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              setDraftLoading(true);
              onSubmit(
                `${HOST_API}${endpoints.leads.post_draft_lead_preview}`,
                true
              );
            }}
            primary={true}
            className="k-button-draft k-mr-2"
            size="large"
            style={{ width: 130 }}
          >
            {draftLoading ? (
              <Loader
                size="small"
                type="converging-spinner"
                style={{ color: "black" }}
              />
            ) : (
              "Save As Draft"
            )}
          </Button>
          <Button
            onClick={() => {
              setLoading(true);
              onSubmit(
                `${HOST_API}${endpoints.leads.post_lead_preview}`,
                false
              );
            }}
            primary={true}
            className="k-button-green"
            size="large"
            style={{ width: 130 }}
          >
            {loading ? (
              <Loader
                size="small"
                type="converging-spinner"
                style={{ color: "white" }}
              />
            ) : (
              "Submit"
            )}
          </Button>
        </div>
      ) : (
        <div className="k-w-full k-d-flex k-justify-content-end k-my-8">
          {/* <Button
            onClick={() => navigate(`/leads/${id}`)}
            primary={true}
            className="k-button k-mr-2"
            size="large"
          >
            Go Back
          </Button> */}
        </div>
      )}
      {showSuccess && (
        <Success
          visible={showSuccess}
          toggleDialog={() => setShowSuccess(false)}
        />
      )}
    </div>
  );
};

export default Preview;
